export const PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

export const SHORTCUT_PLAYBACK_RATES = [-8, -4, -2, -1, 1, 2, 4, 8];
